import React from "react";

export default function BarLoad() {
  return (
    <div id="movingBallG">
      <div className="movingBallLineG"></div>
      <div id="movingBallG_1" className="movingBallG"></div>
    </div>
  );
}
